import { Button } from "@mui/material"
import { useState } from "react"
import { useNotify, useRecordContext, useRedirect, useTranslate } from "react-admin"
import SendEmailDialog from "../../emails/actionDialogs/SendEmailDialog"
import { useMutation } from "react-query";
import { InvoiceReadModel, SendReverseInvoiceByMailCommand, UserReadModel } from "../../GeneratedClients/FreeBillApi";
import { apiService } from "../../apiService";
import { defaultTextReverseInvoice } from "../../emails/actionDialogs/getDefaultText";
import validateEmail from "../../emails/validateEmail";
import MailValidationFailedDialog from "../../emails/actionDialogs/MailValidationFailedDialog";

const SendReverseInvoiceButton = ({user}: {user?: UserReadModel}) => {

  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const reverseInvoice = useRecordContext<InvoiceReadModel>()
  const [open, setOpen] = useState<boolean>(false)
  const { mutate, isLoading } = useMutation((command: SendReverseInvoiceByMailCommand) => 
    apiService.ReverseInvoicesApi.sendReverseInvoice({sendReverseInvoiceByMailCommand: command, id: command.id!}),
    {
      onSuccess: (data) => {
        notify(translate("resources.reverseInvoices.notifications.sent"))
        redirect('list', 'reverseInvoices')
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const record: SendReverseInvoiceByMailCommand = {
    id: reverseInvoice.id, 
    invoiceId: reverseInvoice.canceledInvoiceId!,
    fromAddress: user?.mailServiceConfig?.email,
    fromName: user?.mailServiceConfig?.sender,
    toAddresses: reverseInvoice.invoiceRecipient?.company?.email ? [reverseInvoice.invoiceRecipient?.company?.email] : undefined,
    toName: reverseInvoice.invoiceRecipient?.company?.companyName,
    subject: reverseInvoice.textModel?.heading,
    emailText: defaultTextReverseInvoice(user), 
    userId: reverseInvoice.userId
  }

  const handleSubmit = (command: SendReverseInvoiceByMailCommand) => {
    mutate(command)
  }

  const emailValidation = validateEmail(user?.mailServiceConfig)

  if(!reverseInvoice) return null

  return (
    <>
      <Button 
        onClick={handleOpen} 
        size="small"
      >
        {translate('resources.reverseInvoices.actions.send')}
      </Button>
      {
        !emailValidation.isValid ? (
          <MailValidationFailedDialog 
            message={emailValidation.message} 
            actionButtonText={emailValidation.actionButtonText} 
            open={open}
            handleClose={handleClose}
          />
        ) : (
          <SendEmailDialog 
            record={record} 
            handleSubmit={handleSubmit} 
            attachments={[
              {
                attachmentFileName: `${reverseInvoice.textModel?.heading}.pdf`,
                id: reverseInvoice.id,
                resource: "reverseInvoices"
              }
            ]}
            isLoading={isLoading} 
            resource='reverseInvoices'
            dialogText={translate("resources.reverseInvoices.dialogs.send")}
            open={open}
            handleClose={handleClose}  
          />
        )
      }
    </>
  )
}

export default SendReverseInvoiceButton